import { Routes } from '@angular/router';
import { LoginGuard } from 'src/shared/guards/login.guard';

export const DashboardRoutes: Routes = [
  {
    path: 'dashboard',
    canActivate: [LoginGuard],
    loadComponent: () => import('./pages/dashboard/dashboard.component').then((m) => m.DashboardComponent),
  },
];
